import { memo } from "react";

import Stack from "@mui/material/Stack";

import AppsIcon from "@mui/icons-material/Apps";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import AvTimer from "@mui/icons-material/AvTimer";
import CorporateFareIcon from "@mui/icons-material/CorporateFare";
import Dashboard from "@mui/icons-material/Dashboard";
import FolderOpen from "@mui/icons-material/FolderOpen";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import HomeIcon from "@mui/icons-material/Home";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import MemoryIcon from "@mui/icons-material/Memory";
import OutputIcon from "@mui/icons-material/Output";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import ReceiptIcon from "@mui/icons-material/Receipt";
import SettingsIcon from "@mui/icons-material/Settings";
import ShowChart from "@mui/icons-material/ShowChart";
import TableChartIcon from "@mui/icons-material/TableChart";

import openHelpScout from "utility/helpscout";

import SidebarButton from "./Button";
import SidebarCategory from "./Category";

// -----------------------------------------------------------------------------

const SidebarContent = memo(function Sidebar({
  iconOnly,
}: SidebarProps): JSX.Element {
  return (
    <>
      <Stack direction="column">
        {iconOnly ? (
          <SidebarButton topLevel label="" Icon={HomeIcon} to="/analytics" />
        ) : (
          <SidebarCategory label={"Reporting"} Icon={HomeIcon}>
            <SidebarButton
              label="Mission Control"
              Icon={Dashboard}
              to="/analytics"
            />
            <SidebarButton
              label="Security Health Score"
              Icon={ShowChart}
              to="/analytics/risk"
            />
            <SidebarButton
              label="Identity Access Management"
              Icon={AssignmentIndIcon}
              to="/analytics/iam"
            />
            <SidebarButton
              label="Stale Findings"
              Icon={AvTimer}
              to="/analytics/stale"
            />
          </SidebarCategory>
        )}
        {iconOnly ? (
          <SidebarButton
            topLevel
            label=""
            Icon={AssignmentIcon}
            to="/organization/findings"
          />
        ) : (
          <SidebarCategory label={"Findings"} Icon={AssignmentIcon}>
            <SidebarButton
              label="Overview"
              Icon={TableChartIcon}
              to="/organization/findings"
            />
            <SidebarButton
              label="Rule Management"
              Icon={ManageSearchIcon}
              to="/organization/rule_management"
            />
          </SidebarCategory>
        )}
        {iconOnly ? (
          <SidebarButton
            topLevel
            label=""
            Icon={MemoryIcon}
            to="/environment/sources"
          />
        ) : (
          <SidebarCategory label="Environment" Icon={MemoryIcon}>
            <SidebarButton
              label={iconOnly ? "" : "Sources"}
              Icon={AppsIcon}
              to="/environment/sources"
            />
            <SidebarButton
              label="Destinations"
              Icon={OutputIcon}
              to="/environment/destinations"
            />
          </SidebarCategory>
        )}
        {iconOnly ? (
          <SidebarButton
            topLevel
            label=""
            Icon={CorporateFareIcon}
            to="/organization/settings/general"
          />
        ) : (
          <SidebarCategory label="Organization" Icon={CorporateFareIcon}>
            <SidebarButton
              label="Settings"
              Icon={SettingsIcon}
              to="/organization/settings/general"
            />
            <SidebarButton
              label="Members"
              Icon={PeopleAltIcon}
              to="/organization/members"
            />
            <SidebarButton
              label="Billing"
              Icon={ReceiptIcon}
              to="/organization/settings/billing/plan"
            />
          </SidebarCategory>
        )}
        <SidebarButton
          external
          topLevel
          label={iconOnly ? "" : "Documentation"}
          Icon={FolderOpen}
          to="https://docs.threatkey.com"
          target="_blank"
          rel="noopener noreferrer"
        />
        <SidebarButton
          topLevel
          label={iconOnly ? "" : "Get Support"}
          Icon={HelpOutlineIcon}
          to="#"
          onClick={openHelpScout}
        />
      </Stack>
    </>
  );
});

export default SidebarContent;

// -----------------------------------------------------------------------------

interface SidebarProps {
  iconOnly?: boolean;
}
